<template>
  <Tabs value="iview" :animated="false">
    <TabPane label="iview" name="iview">
      <div class="icon-search">
        <input
          type="text"
          :placeholder="searchPlaceholder"
          @focus="changeHolder('focus')"
          @blur="changeHolder('blur')"
          v-model="search">
      </div>
      <div class="icons">
        <div class="icons-item" v-for="(item,index) in filterIcons" @click = "chooseIconClass(item.name)">
          <i class="ivu-icon" :class="[`ivu-icon-${item.name}`]" style="font-size:32px"></i>
          <p>
            {{ item.name }}
          </p>
        </div>
      </div>
    </TabPane>
    <TabPane label="iconfont" name="iconfont">
      <div class="icon-search">
        <input
          type="text"
          :placeholder="searchPlaceholder"
          @focus="changeHolder('focus')"
          @blur="changeHolder('blur')"
          v-model="searchIcon">
      </div>
      <div class="icons">
        <div class="icons-item" v-for="(item,index) in filterIconfonts"  @click = "chooseIconClass(`iconfont icon${item.name}`)">
          <i class="ivu-icon-iconfont" :class="[`icon${item.name}`]" style="font-size:32px"></i>
          <p style="padding-top: 0px;  word-wrap: break-word;word-break: break-all;overflow: hidden;">
            {{ item.name }}
          </p>
        </div>
      </div>
    </TabPane>
    <TabPane label="png16" name="png16">
      <div class="icon-search">
        <input
          type="text"
          :placeholder="searchPlaceholder"
          @focus="changeHolder('focus')"
          @blur="changeHolder('blur')"
          v-model="search16">
      </div>
      <div class="icons">
        <div class="icons-item" v-for="(item,index) in filterPng16"  @click = "chooseIconClass(`img ivu-img-16 ivu-img-${item.name}`)">
          <i class="ivu-img-16" :class="[`ivu-img-${item.name}`]"></i>
          <p>
            {{ item.name }}
          </p>
        </div>
      </div>
    </TabPane>
    <TabPane label="png22" name="png22">
    </TabPane>
    <TabPane label="png24" name="png24">标签三的内容</TabPane>
    <TabPane label="png32" name="png32">标签三的内容</TabPane>
  </Tabs>
</template>

<script>
  import Icons from '@/code/iconname';
  import iconfonts from '@/code/iconfont';
  import Png16 from '@/code/smallImgName';
  const searchPlaceholder = '输入英文关键词搜索，比如 success';
  export default {
    name: "m-icon",
    data(){
      return{
        searchPlaceholder: searchPlaceholder,
        search: '',
        searchIcon:'',
        search16:'',
        icons: Icons,
        iconfont:iconfonts,
        png16:Png16,
      }
    },
    created(){

    },
    computed: {
      filterIcons () {
        return this.icons.filter(icon => icon.tag.indexOf(this.search) > -1);
      },
      filterPng16 () {
        return this.png16.filter(icon => icon.tag.indexOf(this.search16) > -1);
      },
      filterIconfonts (){
        return this.iconfont.filter(icon => icon.tag.indexOf(this.searchIcon) > -1);
      }
    },
    methods:{
      changeHolder (type) {
        if (type === 'focus') {
          this.searchPlaceholder = '';
        } else if (type === 'blur') {
          this.searchPlaceholder = searchPlaceholder;
        }
      },
      //选择图标
      chooseIconClass(item){
        this.$emit("save", item);
      }
    }
  }
</script>

<style scoped>
  .icon-search{
    position: relative;
    margin: 20px auto 30px;
    text-align: center;
  }
  .icon-search input {
    width: 500px;
    box-sizing: border-box;
    border: 0;
    border-radius: 4px;
    background: #fafafa;
    text-align: center;
    font-size: 14px;
    outline: none;
    margin: 0 auto;
    padding: 8px 0;
  }
  .icons{
    overflow: auto;
    zoom: 1;
    padding-left: 10px;
    height: calc(100vh - 255px);
  }
  .icons-item{
    float: left;
    margin: 6px 6px 6px 0;
    width: 120px;
    text-align: center;
    list-style: none;
    cursor: pointer;
    height: 100px;
    color: #5c6b77;
    transition: all .2s ease;
    position: relative;
    padding-top: 10px;
  }
  .icons-item p{
    padding-top: 15px;
  }
  .btn-bar{
    position: absolute;
    background: rgba(178,181,183,0.4);
    width: 130px;
    height: 115px;
    border-radius: 10px;
    top:0;
  }
  .btn{
    margin-top: 80px;
  }
</style>
